import { NgModule } from "@angular/core";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { S25PillComponent } from "./s25.pill.component";

@NgModule({
    declarations: [S25PillComponent],
    exports: [S25PillComponent],
    imports: [S25IconComponent],
    providers: [S25PillComponent],
})
export class S25PillModule {}
